module.exports = __webpack_public_path__ + "ibm.png?a86d857b71dbd6f2fb1ab8601d08109a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/ibm.png
// module id = 182
// module chunks = 0